import { render, staticRenderFns } from "./ProjectInfoVertical.vue?vue&type=template&id=de2fd51c"
import script from "./ProjectInfoVertical.vue?vue&type=script&lang=js"
export * from "./ProjectInfoVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports